export const categories = [
  {
    slug: 'online-tools',
    name: '在线工具',
    description: '实用在线工具合集，文档转换、图片处理、计算器等常用工具一应俱全',
    icon: 'ri-tools-line',
    articleCount: 28,
  },
  {
    slug: 'entertainment',
    name: '娱乐休闲',
    description: '在线游戏、音乐播放、视频观看等娱乐内容，放松身心的最佳选择',
    icon: 'ri-gamepad-line',
    articleCount: 35,
  },
  {
    slug: 'education',
    name: '学习教育',
    description: '在线课程、知识问答、学习资料等教育资源共享平台',
    icon: 'ri-book-open-line',
    articleCount: 42,
  },
  {
    slug: 'life-services',
    name: '生活服务',
    description: '天气查询、地图导航、健康管理等日常生活便利服务',
    icon: 'ri-heart-pulse-line',
    articleCount: 19,
  },
  {
    slug: 'office',
    name: '办公效率',
    description: '在线文档编辑、项目管理、团队协作等办公效率提升工具',
    icon: 'ri-briefcase-line',
    articleCount: 31,
  },
  {
    slug: 'creative-design',
    name: '创意设计',
    description: '在线图片编辑、配色方案、设计素材等创意设计辅助工具',
    icon: 'ri-paint-brush-line',
    articleCount: 24,
  },
];

export const categoryDetails: Record<string, { name: string; description: string; icon: string }> = {
  'online-tools': { name: '在线工具', description: '实用在线工具合集，文档转换、图片处理、计算器等常用工具一应俱全', icon: 'ri-tools-line' },
  'entertainment': { name: '娱乐休闲', description: '在线游戏、音乐播放、视频观看等娱乐内容，放松身心的最佳选择', icon: 'ri-gamepad-line' },
  'education': { name: '学习教育', description: '在线课程、知识问答、学习资料等教育资源共享平台', icon: 'ri-book-open-line' },
  'life-services': { name: '生活服务', description: '天气查询、地图导航、健康管理等日常生活便利服务', icon: 'ri-heart-pulse-line' },
  'office': { name: '办公效率', description: '在线文档编辑、项目管理、团队协作等办公效率提升工具', icon: 'ri-briefcase-line' },
  'creative-design': { name: '创意设计', description: '在线图片编辑、配色方案、设计素材等创意设计辅助工具', icon: 'ri-paint-brush-line' },
};